import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { GoogleAnalyticsService } from 'ngx-google-analytics';
import { Subscription } from 'rxjs';
import { User } from 'src/app/models/models';
import { AtivacoesService } from './../../../services/ativacoes.service';
import { SecurityService } from './../../../services/security.service';
import { FirebaseRequestsService } from '../../../services/requests/firebase/firebase-requests.service';
import { VendedorInfo } from '../../../models/models';

@Component({
  selector: 'app-campanha',
  templateUrl: './campanha.component.html',
  styleUrls: ['./campanha.component.scss'],
})
export class CampanhaComponent implements OnInit, OnDestroy {
  user: User;
  canShow = false;
  routeSubscription!: Subscription;
  vendedorInfo: VendedorInfo | null = null; 
  
  constructor(
    public ativacoesService: AtivacoesService,
    public securityService: SecurityService,
    private $gaService: GoogleAnalyticsService,
    private activatedRoute: ActivatedRoute,
    private fireReqs: FirebaseRequestsService
  ) {}

  ngOnInit(): void {
    this.$gaService.pageView('/campanha', 'Campanha');
    this.user = this.securityService.currentUserValue;
    this.fireReqs.obterVendedorAtual().subscribe((info) => {
      this.vendedorInfo = info; // Atualiza a variável quando os dados chegam
    });
    this.routeSubscription = this.activatedRoute.queryParams.subscribe(
      (queryParams) => {
        const campaignName =
          queryParams.campaignName && this.securityService.canChooseCampaign
            ? queryParams.campaignName
            : null;

        this.securityService.setCampaign(campaignName).then((res) => {
          this.canShow = true;
        });
      }
    );
  }

  ngOnDestroy() {
    if (this.routeSubscription) {
      this.routeSubscription.unsubscribe();
    }
  }
}
